export const setCarwashCoupon = async (context, carwashCoupon) => {
  context.commit('SET_CARWASH_COUPON', carwashCoupon)
}
